import { SnowplowService } from 'wanderu-service-analytics';

const sendEvent = (action, label, property) => SnowplowService.fireStructuredEventWithBatchId({
    action,
    category: 'react_tripsummary',
    label,
    property,
});

const clickPolicyEvent = (property) => sendEvent('click', 'carrier_link', property);

const events = {
    clickPolicyEvent,
};

export default events;
